import React from "react";
import { createRoot } from 'react-dom/client';

import App from './App';
import HttpsRedirect from "react-https-redirect";
import { ErrorBoundary } from './components/templateComponent/error-boundary.jsx';

// ----------------------------------------------------------------------

import StoreManager from "./redux/index"
StoreManager.getStore();


const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <HttpsRedirect disabled={!window.g_settings.isSupportHTTPS}>
        <ErrorBoundary >
            <App />
        </ErrorBoundary>
    </HttpsRedirect>
);
